import {
  ReservationStatus,
  ReservationWithRelations,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kSeats } from "./seats";
import { kUsers } from "./users";

export const kReservations: ReservationWithRelations[] = [
  {
    id: "00000011-0000-4000-a000-000000000006",
    user: kUsers[0],
    seat: kSeats[0],
    from: "08:00",
    to: "12:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T08:00:00+01:00",
    dateEnd: "2020-10-30T12:00:00+01:00",
    type: "normal",
    includeParking: false,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-000000000007",
    user: kUsers[1],
    seat: kSeats[1],
    from: "08:00",
    to: "18:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T08:00:00+01:00",
    dateEnd: "2020-10-30T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-100000000003",
    user: kUsers[2],
    seat: kSeats[2],
    from: "09:00",
    to: "18:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T09:00:00+01:00",
    dateEnd: "2020-10-30T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-100000000004",
    user: kUsers[3],
    seat: kSeats[3],
    from: "09:00",
    to: "18:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T09:00:00+01:00",
    dateEnd: "2020-10-30T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-100000000005",
    user: kUsers[4],
    seat: kSeats[4],
    from: "09:00",
    to: "18:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T09:00:00+01:00",
    dateEnd: "2020-10-30T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-100000000006",
    user: kUsers[5],
    seat: kSeats[5],
    from: "09:00",
    to: "18:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T09:00:00+01:00",
    dateEnd: "2020-10-30T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-100000000007",
    user: kUsers[6],
    seat: kSeats[6],
    from: "09:00",
    to: "18:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T09:00:00+01:00",
    dateEnd: "2020-10-30T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-100000000008",
    user: kUsers[7],
    seat: kSeats[7],
    from: "09:00",
    to: "18:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T09:00:00+01:00",
    dateEnd: "2020-10-30T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-100000000009",
    user: kUsers[8],
    seat: kSeats[8],
    from: "09:00",
    to: "18:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T09:00:00+01:00",
    dateEnd: "2020-10-30T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "00000011-0000-4000-a000-100000000010",
    user: kUsers[9],
    seat: kSeats[9],
    from: "09:00",
    to: "18:00",
    date: "2020-10-30",
    dateStart: "2020-10-30T09:00:00+01:00",
    dateEnd: "2020-10-30T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "290a7a8f-d4b6-484f-a63c-01d41ed099b2",
    user: kUsers[10],
    seat: kSeats[1],
    from: "10:00",
    to: "18:00",
    date: "2025-03-21",
    dateStart: "2025-03-21T10:00:00+01:00",
    dateEnd: "2025-03-21T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "5190bacf-5e55-4ef1-9d3d-0e873b5a9892",
    user: kUsers[1],
    seat: kSeats[3],
    from: "12:00",
    to: "18:00",
    date: "2025-03-21",
    dateStart: "2025-03-21T12:00:00+01:00",
    dateEnd: "2025-03-21T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "a4ceecf9-ea59-47a6-a564-8857e7309fb0",
    user: kUsers[0],
    seat: kSeats[2],
    from: "11:00",
    to: "18:00",
    date: "2025-03-21",
    dateStart: "2025-03-21T11:00:00+01:00",
    dateEnd: "2025-03-21T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-22T20:59:45+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "015291d5-2a00-4726-8fae-3aab67642c5f",
    user: kUsers[0],
    seat: kSeats[2],
    from: "11:00",
    to: "18:00",
    date: "2025-03-22",
    dateStart: "2025-03-22T11:00:00+01:00",
    dateEnd: "2025-03-22T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-23T17:15:24+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "0191f482-f7f5-4c58-aa5c-2365cf815980",
    user: kUsers[1],
    seat: kSeats[3],
    from: "12:00",
    to: "18:00",
    date: "2025-03-22",
    dateStart: "2025-03-22T12:00:00+01:00",
    dateEnd: "2025-03-22T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-23T17:15:26+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "03d8cc8f-1c31-468c-a7b1-363f7c3040f1",
    user: kUsers[1],
    seat: kSeats[4],
    from: "12:00",
    to: "18:00",
    date: "2025-03-22",
    dateStart: "2025-03-22T12:00:00+01:00",
    dateEnd: "2025-03-22T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-23T17:15:22+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "0a89e778-c09b-4e10-910c-00b74a298a9b",
    user: kUsers[1],
    seat: kSeats[4],
    from: "12:00",
    to: "18:00",
    date: "2025-03-22",
    dateStart: "2025-03-22T12:00:00+01:00",
    dateEnd: "2025-03-22T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-23T17:15:33+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "0a929a91-e0db-45bc-ac37-16b8a4b75e05",
    user: kUsers[10],
    seat: kSeats[1],
    from: "10:00",
    to: "18:00",
    date: "2025-03-22",
    dateStart: "2025-03-22T10:00:00+01:00",
    dateEnd: "2025-03-22T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-23T17:15:29+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "0b91684d-2fa1-4d18-be05-c3863dde9d2e",
    user: kUsers[10],
    seat: kSeats[1],
    from: "10:00",
    to: "18:00",
    date: "2025-03-22",
    dateStart: "2025-03-22T10:00:00+01:00",
    dateEnd: "2025-03-22T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-23T17:15:33+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
  {
    id: "0f13062f-dbe0-4724-89db-0287e617e6fd",
    user: kUsers[0],
    seat: kSeats[1],
    from: "11:00",
    to: "18:00",
    date: "2025-03-22",
    dateStart: "2025-03-22T11:00:00+01:00",
    dateEnd: "2025-03-22T18:00:00+01:00",
    type: "normal",
    includeParking: true,
    visitorName: "",
    visitorEmail: "",
    visitorPhone: "",
    expiresAt: null,
    expiredAt: null,
    cancelled: false,
    cancelledReason: "",
    status: "reserved" as ReservationStatus,
    companyTransportOptionId: null,
    created: "2025-03-23T17:15:34+01:00",
    title: null,
    description: null,
    _operations: {
      canCancel: false,
    },
  },
];
